import { Loading } from "components";
import ApplicationSummary from "components/ApplicationSummary";
import { TabComponentProps } from "../../types";
import "./styles.scss";

export default function ApplicationPageDetails({ application }: TabComponentProps) {
	return !application ? (
		<Loading />
	) : (
		<div className="backoffice-application-details">
			<ApplicationSummary values={application} showBackofficeFields />
		</div>
	);
}
